<template>
    <div class="details__container" :id="detailsTitleId">
        <span class="details__title">{{ $t("lang.pages.tariff.details.title") }}</span>
        <div class="details__content">
            <div class="details__table">
                <div class="details__table_row" v-for="(row, k) in preparedData">
                    <template v-for="column in row">
                        <div v-if="typeof column === 'object'" class="details__table_cell flex align-items-center justify-content-between gap-2">
                            <span v-if="typeof column.text !== 'undefined'">{{ column.text }}</span>
                            <Popper hover arrow placement="left">
                                <i class="pi pi-question-circle"></i>
                                <template #content>
                                    <div class="text-xs text-left flex flex-column align-items-end">
                                        <span v-if="typeof column.title !== 'undefined'">{{ column.title }}</span>
                                        <a v-if="typeof column.url !== 'undefined'" :href="column.url" target="_blank">
                                            {{ $t("lang.pages.tariff.details.tooltip_show_more") }} <i class="pi pi-external-link text-xs ml-1"></i>
                                        </a>
                                    </div>
                                </template>
                            </Popper>
                        </div>
                        <div v-else class="details__table_cell" v-html="column"></div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {FormatHelper} from "../../../helpers/FormatHelper";
import Limits from "../../../mixins/Limits";

export default {
    name: "TariffPageDetails",
    mixins: [Limits],
    data() {
        /** Ключ необходим для цикла, что б описание было в первой колонке */
        return {
            preparedData: [],
            elementKey: 0,
        };
    },
    props: {
        tariffTemplates: Object,
        detailsTitleId: {
            type: String,
            required: true
        }
    },
    created() {
        this.preparedData = this.getFormattedOptionsLabel();
        [...Object.values(this.tariffTemplates)].forEach((tariff) => {
            this.elementKey++;
            this.preparedData.cellTitle[this.elementKey] = tariff.label;
            this.preparedData.cellShortTitle[this.elementKey] = tariff.labelShort;
            this.preparedData.analyze[this.elementKey] = this.formatValue(true);
            this.preparedData.monitoring[this.elementKey] = this.formatValue(true);
            this.preparedData.monitoringMonthLimit[this.elementKey] = this.formatValue(tariff.serpProjectsKeysPerMonth);
            this.preparedData.aiTracker[this.elementKey] = this.formatValue(true);
            this.preparedData.aiTrackerExecuteRequests[this.elementKey] = this.formatValue(tariff.aiExecutePerMonth);
            this.preparedData.aiTrackerPromptsLimit[this.elementKey] = this.formatValue(tariff.aiPromptsLimit);
            this.preparedData.analyzeLinks[this.elementKey] = this.formatValue(tariff.isLinksAvailable);
            this.preparedData.recordsPerReport[this.elementKey] = this.isUnlimit(tariff.recordsPerReport) ? this.$t("lang.limitModal.unlimit") : this.formatWithMobile(tariff.recordsPerReport);
            this.preparedData.analyzePerDay[this.elementKey] = this.formatWithMobile(tariff.analyzePerDay);
            this.preparedData.projectsLimit[this.elementKey] = this.formatValue(tariff.projectsLimit);
            this.preparedData.compare[this.elementKey] = this.formatValue(true);
            this.preparedData.sitesNumberToCompare[this.elementKey] = this.formatWithMobile(tariff.sitesNumberToCompare);
            this.preparedData.groupReports[this.elementKey] = this.formatValue(true);
            this.preparedData.keysPerGroupReport[this.elementKey] = this.isUnlimit(tariff.keysPerGroupReport) ? this.$t("lang.limitModal.unlimit") : this.formatWithMobile(tariff.keysPerGroupReport);
            this.preparedData.searchKeys[this.elementKey] = this.formatValue(tariff.searchKeysPerDay) + '/' + this.formatValue(tariff.searchKeysPerMonth);
            this.preparedData.domainsBatch[this.elementKey] = this.formatValue(tariff.domainsBatchPerDay) + '/' + this.formatValue(tariff.domainsBatchPerMonth);
            this.preparedData.rsyaPerDay[this.elementKey] = this.formatWithMobile(tariff.rsyaPerDay);
            this.preparedData.rsyaRowsLimit[this.elementKey] = this.isUnlimit(tariff.rsyaExportRowsLimit) ? this.$t("lang.limitModal.unlimit") : this.formatWithMobile(tariff.rsyaExportRowsLimit);
            this.preparedData.sessionTimeout[this.elementKey] = this.formatValue(
                tariff.sessionTimeout,
                this.$t("lang.pages.tariff.details.minutes")
            );
            this.preparedData.usersNumber[this.elementKey] = this.formatValue(tariff.usersNumber);
            this.preparedData.isApiAvailable[this.elementKey] = this.formatValue(tariff.isApiAvailable);
            if (tariff.isApiAvailable) {
                this.preparedData.perPageLimit[this.elementKey] = this.formatValue(tariff.perPageLimit);
            } else {
                this.preparedData.perPageLimit[this.elementKey] = this.formatValue(tariff.isApiAvailable);
            }
            this.preparedData.requestsPerDay[this.elementKey] = this.formatWithMobile(tariff.requestsPerDay);
            this.preparedData.suggestPerDay[this.elementKey] = this.formatValue(tariff.suggestPerDay);
            this.preparedData.wordstat[this.elementKey] = this.formatValue(true);
            this.preparedData.wordstatMaxActiveProjects[this.elementKey] = this.formatValue(tariff.wordstatMaxActiveProjects);
            this.preparedData.wordstatPerMonth[this.elementKey] = this.formatValue(tariff.wordstatPerMonth);
            this.preparedData.wordstatWord[this.elementKey] = this.formatValue(true);
            this.preparedData.wordstatWordPerMonth[this.elementKey] = this.formatValue(tariff.wordstatWordPerMonth);
            this.preparedData.serpMaxActiveProjects[this.elementKey] = this.formatValue(tariff.serpMaxActiveProjects);
            this.preparedData.serpProjectsKeysPerMonth[this.elementKey] = this.formatValue(tariff.serpProjectsKeysPerMonth);
            this.preparedData.cluster[this.elementKey] = this.formatValue(true);
            this.preparedData.clusterWordsLimit[this.elementKey] = this.formatValue(tariff.clusterWordsLimit);
            this.preparedData.clusterNumberLimit[this.elementKey] = this.formatValue(tariff.clusterNumberLimit);
            this.preparedData.concurrents[this.elementKey] = this.formatValue(true);
            this.preparedData.themes[this.elementKey] = this.formatValue(true);
            this.preparedData.pages[this.elementKey] = this.formatValue(true);
            this.preparedData.dictionary[this.elementKey] = this.formatValue(true);
            this.preparedData.extDictionary[this.elementKey] = this.formatValue(true);
            this.preparedData.words[this.elementKey] = this.formatValue(true);
            this.preparedData.extWords[this.elementKey] = this.formatValue(true);
            this.preparedData.cleaningDuplicates[this.elementKey] = this.formatValue(true);
            this.preparedData.uniqWords[this.elementKey] = this.formatValue(true);
            this.preparedData.top[this.elementKey] = this.formatValue(true);
            this.preparedData.compareWords[this.elementKey] = this.formatValue(true);
            this.preparedData.combineWords[this.elementKey] = this.formatValue(true);
            this.preparedData.massCheck[this.elementKey] = this.formatValue(true);
            this.preparedData.export[this.elementKey] = this.formatValue(true);
            this.preparedData.keywordsByPages[this.elementKey] = this.formatValue(true);
            this.preparedData.keywordsByPagesLimit[this.elementKey] = this.formatWithMobile(tariff.keywordsByPages);
            this.preparedData.keywordsByListLimit[this.elementKey] = this.formatWithMobile(tariff.keywordsByListLimit);
            this.preparedData.domainsBatchListLimit[this.elementKey] = this.formatWithMobile(tariff.domainsBatchListLimit);
            this.preparedData.sitesCompare[this.elementKey] = this.isUnlimit(tariff.sitesCompare) ? this.$t("lang.limitModal.unlimit") : this.formatWithMobile(tariff.sitesCompare);
        });
    },
    computed: {
        getElementYes() {
            return '<img src="/i/icons/yes.svg" />';
        },
        getElementNo() {
            return '<img src="/i/icons/no.svg" />';
        }
    },
    methods: {
        formatValue(value, prefix = '') {
            if (value === true) {
                return this.getElementYes;
            }

            if (!value) {
                return this.getElementNo;
            }

            return FormatHelper.number(value, prefix);
        },
        formatDigitsValue(value) {
            if (value === true) {
                return this.getElementYes;
            }

            if (!value) {
                return this.getElementNo;
            }

            return FormatHelper.numberDigits(value);
        },
        formatWithMobile(value) {
            return sprintf(
                '<span class="details__desktop_value">%s</span><span class="details__mobile_value">%s</span>',
                this.formatValue(value),
                this.formatDigitsValue(value)
            );
        },
        getFormattedOptionsLabel() {
            return {
                cellTitle: {[this.elementKey]: this.$t("lang.pages.tariff.details.cellTitle")},
                cellShortTitle: {[this.elementKey]: this.$t("lang.pages.tariff.details.cellTitle")},
                analyze: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.analyze"),
                    title: this.$t("lang.pages.tariff.details.analyzeTitle"),
                }},
                analyzeLinks: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.analyzeLinks"),
                    title: this.$t("lang.pages.tariff.details.analyzeLinksTitle"),
                    url: this.$t("lang.pages.tariff.details.analyzeLinksHelpUrl"),
                }},
                recordsPerReport: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.recordsPerReport"),
                    title: this.$t("lang.pages.tariff.details.recordsPerReportTitle"),
                }},
                analyzePerDay: {[this.elementKey]: {
                    text: this.$tm("lang.pages.tariff.details.analyzePerDay"),
                    title: this.$t("lang.pages.tariff.details.analyzePerDayTitle"),
                }},
                monitoring: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.monitoring"),
                    title: this.$t("lang.pages.tariff.details.monitoringTitle"),
                    url: this.$t("lang.pages.tariff.details.monitoringUrl"),
                }},
                monitoringMonthLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.monitoringMonthLimit"),
                    title: this.$t("lang.pages.tariff.details.monitoringMonthLimitTitle"),
                }},
                aiTracker: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.aiTracker"),
                    title: this.$t("lang.pages.tariff.details.aiTrackerTitle"),
                    url: this.$t("lang.pages.tariff.details.aiTrackerUrl"),
                }},
                aiTrackerExecuteRequests: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.aiTrackerExecuteRequests"),
                    title: this.$t("lang.pages.tariff.details.aiTrackerExecuteRequestsTitle"),
                }},
                aiTrackerPromptsLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.aiTrackerPromptsLimit"),
                    title: this.$t("lang.pages.tariff.details.aiTrackerPromptsLimitTitle"),
                }},
                projectsLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.projectsLimit"),
                    title: this.$t("lang.pages.tariff.details.projectsLimitTitle"),
                    url: this.$t("lang.pages.tariff.details.projectsLimitHelpUrl"),
                }},
                compare: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.compare"),
                    title: this.$t("lang.pages.tariff.details.compareTitle"),
                    url: this.$t("lang.pages.tariff.details.compareHelpUrl"),
                }},
                sitesNumberToCompare: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.sitesNumberToCompare"),
                    title: this.$t("lang.pages.tariff.details.sitesNumberToCompareTitle"),
                }},
                groupReports: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.groupReports"),
                    title: this.$t("lang.pages.tariff.details.groupReportsTitle"),
                    url: this.$t("lang.pages.tariff.details.groupReportsHelpUrl"),
                }},
                keysPerGroupReport: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.keysPerGroupReport"),
                    title: this.$t("lang.pages.tariff.details.keysPerGroupReportTitle"),
                }},
                searchKeys: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.searchKeys"),
                    title: this.$t("lang.pages.tariff.details.searchKeysTitle"),
                }},
                domainsBatch: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.domainsBatch"),
                    title: this.$t("lang.pages.tariff.details.domainsBatchTitle"),
                }},
                rsyaPerDay: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.rsyaPerDay"),
                    title: this.$t("lang.pages.tariff.details.rsyaPerDayTitle"),
                }},
                rsyaRowsLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.rsyaExportRowsLimit"),
                    title: this.$t("lang.pages.tariff.details.rsyaExportRowsLimitTitle"),
                }},
                sessionTimeout: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.sessionTimeout"),
                    title: this.$t("lang.pages.tariff.details.sessionTimeoutTitle"),
                }},
                usersNumber: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.usersNumber"),
                    title: this.$t("lang.pages.tariff.details.usersNumberTitle"),
                }},
                isApiAvailable: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.isApiAvailable"),
                    title: this.$t("lang.pages.tariff.details.isApiAvailableTitle"),
                }},
                requestsPerDay: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.requestsPerDay"),
                    title: this.$t("lang.pages.tariff.details.requestsPerDayTitle"),
                }},
                perPageLimit: {[this.elementKey]: {
                        text: this.$t("lang.pages.tariff.details.perPageLimit"),
                        title: this.$t("lang.pages.tariff.details.perPageLimitTitle"),
                }},
                suggestPerDay: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.suggestPerDay"),
                    title: this.$t("lang.pages.tariff.details.suggestPerDayTitle"),
                }},
                wordstat: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.wordstat"),
                    title: this.$t("lang.pages.tariff.details.wordstatTitle"),
                }},
                wordstatMaxActiveProjects: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.wordstatMaxActiveProjects"),
                    title: this.$t("lang.pages.tariff.details.wordstatMaxActiveProjectsTitle"),
                }},
                wordstatPerMonth: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.wordstatPerMonthLimit"),
                    title: this.$t("lang.pages.tariff.details.wordstatPerMonthLimitTitle"),
                }},
                wordstatWord: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.wordstatWord"),
                    title: this.$t("lang.pages.tariff.details.wordstatWordTitle"),
                }},
                wordstatWordPerMonth: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.wordstatWordPerMonthLimit"),
                    title: this.$t("lang.pages.tariff.details.wordstatWordPerMonthLimitTitle"),
                }},
                serpMaxActiveProjects: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.serpMaxActiveProjects"),
                    title: this.$t("lang.pages.tariff.details.serpMaxActiveProjectsTitle"),
                }},
                serpProjectsKeysPerMonth: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.serpProjectsKeysPerMonth"),
                    title: this.$t("lang.pages.tariff.details.serpProjectsKeysPerMonthTitle"),
                }},
                cluster: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.cluster"),
                    title: this.$t("lang.pages.tariff.details.clusterTitle"),
                    url: this.$t("lang.pages.tariff.details.clusterHelpUrl"),
                }},
                clusterWordsLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.clusterWordsLimit"),
                    title: this.$t("lang.pages.tariff.details.clusterWordsLimitTitle"),
                }},
                clusterNumberLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.clusterNumberLimit"),
                    title: this.$t("lang.pages.tariff.details.clusterNumberLimitTitle"),
                }},
                concurrents: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.concurrents"),
                    title: this.$t("lang.pages.tariff.details.concurrentsTitle"),
                    url: this.$t("lang.pages.tariff.details.concurrentsHelpUrl"),
                }},
                themes: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.themes"),
                    title: this.$t("lang.pages.tariff.details.themesTitle"),
                    url: this.$t("lang.pages.tariff.details.themesHelpUrl"),
                }},
                pages: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.pages"),
                    title: this.$t("lang.pages.tariff.details.pagesTitle"),
                    url: this.$t("lang.pages.tariff.details.pagesHelpUrl"),
                }},
                dictionary: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.dictionary"),
                    title: this.$t("lang.pages.tariff.details.dictionaryTitle"),
                    url: this.$t("lang.pages.tariff.details.dictionaryHelpUrl"),
                }},
                extDictionary: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.extDictionary"),
                    title: this.$t("lang.pages.tariff.details.extDictionaryTitle"),
                    url: this.$t("lang.pages.tariff.details.extDictionaryHelpUrl"),
                }},
                words: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.words"),
                    title: this.$t("lang.pages.tariff.details.wordsTitle"),
                    url: this.$t("lang.pages.tariff.details.wordsHelpUrl"),
                }},
                extWords: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.extWords"),
                    title: this.$t("lang.pages.tariff.details.extWordsTitle"),
                    url: this.$t("lang.pages.tariff.details.extWordsHelpUrl"),
                }},
                cleaningDuplicates: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.cleaningDuplicates"),
                    title: this.$t("lang.pages.tariff.details.cleaningDuplicatesTitle"),
                    url: this.$t("lang.pages.tariff.details.cleaningDuplicatesHelpUrl"),
                }},
                uniqWords: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.uniqWords"),
                    title: this.$t("lang.pages.tariff.details.uniqWordsTitle"),
                    url: this.$t("lang.pages.tariff.details.uniqWordsHelpUrl"),
                }},
                top: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.top"),
                    title: this.$t("lang.pages.tariff.details.topTitle"),
                    url: this.$t("lang.pages.tariff.details.topHelpUrl"),
                }},
                compareWords: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.compareWords"),
                    title: this.$t("lang.pages.tariff.details.compareWordsTitle"),
                    url: this.$t("lang.pages.tariff.details.compareWordsHelpUrl"),
                }},
                combineWords: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.combineWords"),
                    title: this.$t("lang.pages.tariff.details.combineWordsTitle"),
                    url: this.$t("lang.pages.tariff.details.combineWordsHelpUrl"),
                }},
                massCheck: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.massCheck"),
                    title: this.$t("lang.pages.tariff.details.massCheckTitle"),
                    url: this.$t("lang.pages.tariff.details.massCheckHelpUrl"),
                }},
                export: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.export"),
                    title: this.$t("lang.pages.tariff.details.exportTitle"),
                }},
                keywordsByPages: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.keywordsByPages"),
                    title: this.$t("lang.pages.tariff.details.keywordsByPagesTitle"),
                    url: this.$t("lang.pages.tariff.details.keywordsByPagesUrl"),
                }},
                keywordsByPagesLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.maxRequestRowsListOfPageRequests"),
                    title: this.$t("lang.pages.tariff.details.keywordsByPagesTitle"),
                    url: this.$t("lang.pages.tariff.details.keywordsByPagesUrl"),
                }},
                keywordsByListLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.maxRequestRowsCompetitors"),
                    title: this.$t("lang.pages.tariff.details.maxRequestRowsCompetitors"),
                    url: this.$t("lang.pages.tariff.details.maxRequestRowsCompetitorsUrl"),
                }},
                domainsBatchListLimit: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.maxRequestRowsBatch"),
                    title: this.$t("lang.pages.tariff.details.maxRequestRowsBatchTitle"),
                    url: this.$t("lang.pages.tariff.details.maxRequestRowsBatchUrl"),
                }},
                sitesCompare: {[this.elementKey]: {
                    text: this.$t("lang.pages.tariff.details.maxRequestSiteCompare"),
                    title: this.$t("lang.pages.tariff.details.maxRequestSiteCompareTitle"),
                    url: this.$t("lang.pages.tariff.details.maxRequestSiteCompareUrl"),
                }},
            }
        },
    },
}
</script>

<style scoped>
.details__container {
    display: flex;
    flex-direction: column;
}
.details__title {
    font-size: 36px;
    line-height: 40px;
    color: #232D35;
}
.details__content {
    margin: 28px 0 80px;
}
.details__table {
    display: flex;
    flex-direction: column;
}
.details__table_row:nth-child(2) {
    display: none;
    background-color: #EBF1F6;
}
.details__table_row:first-child,
.details__table_row:nth-child(2) {
    font-weight: 500;
    position: sticky;
    top: 59px;
    z-index: 999;
    flex-flow: row nowrap;
    border-top: 1px solid #A4B1BE;
    border-bottom: 1px solid #A4B1BE;
    padding: 8px 0;
    background-color: #fff;
    font-size: 20px;
    line-height: 32px;
}
.details__table_row {
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    font-size: 16px;
    line-height: 24px;
    padding: 17px 8px;
}
.details__table_row:deep(img) {
    width: 20px !important;
}
.details__table_row:nth-child(2) .details__table_cell:first-child {
    display: none;
}
.details__table_cell:first-child {
    flex: 1 40%;
    text-align: left;
}
.details__table_cell {
    flex: 1 15%;
    text-align: center;
}
.details__table_cell:deep(.details__mobile_value) {
    display: none;
}

@media (max-width: 1200px) {
    .details__table_row:first-child,
    .details__table_row:nth-child(2) {
        top: 56px;
        background: #EBF1F7;
        border-radius: 4px;
        border: none;
    }
    .details__table_row:first-child .details__table_cell:first-child {
        display: none;
    }
    .details__table_row {
        border-bottom: 1px solid #A4B1BE;
    }
    .details__table_cell:first-child {
        flex: 1 100%;
        text-align: center;
        margin: 16px 0 8px;
        justify-content: center !important;
    }
    .details__table_cell:not(:first-child) {
        flex: 1 25%;
        margin-top: 16px;
    }
}

@media (max-width: 800px) {
    .details__table_row:first-child {
        display: none;
    }
    .details__table_row:nth-child(2) {
        display: flex;
    }
    .details__table_cell:deep(.details__mobile_value) {
        display: block;
    }
    .details__table_cell:deep(.details__desktop_value) {
        display: none;
    }
}
</style>
